var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Slider as SliderMui, Stack } from '@mui/material';
import { useState } from 'react';
import { converMonthToString, converYearMonthToString, getYearAndMonthInStringDate, } from '../services/dashboard';
import { ExpandIcon, ExpandLessIcon } from './Icons';
import { concatYearsAndMonth, getMonthBetweenTowMonth, } from '../services/utils/utils';
import { IconButton } from './IconButton';
var addMonth = function (value, nbMonthAdd) {
    var _a = getYearAndMonthInStringDate(value), Annee = _a.Annee, Mois = _a.Mois;
    for (var i = 0; i < Math.abs(nbMonthAdd); i++) {
        if (nbMonthAdd > 0) {
            if (Mois === 12) {
                Annee += 1;
                Mois = 1;
            }
            else {
                Mois += 1;
            }
        }
        else {
            if (Mois === 1) {
                Annee -= 1;
                Mois = 12;
            }
            else {
                Mois -= 1;
            }
        }
    }
    return concatYearsAndMonth(Annee, Mois);
};
export var SliderMonth = function (_a) {
    var _b = _a.onChange, onChange = _b === void 0 ? null : _b, defaultDebut = _a.defaultDebut, defaultFin = _a.defaultFin, _c = _a.minDiff, minDiff = _c === void 0 ? null : _c, _d = _a.maxDiff, maxDiff = _d === void 0 ? null : _d;
    var _e = useState(addMonth(defaultDebut, -2)), min = _e[0], setMin = _e[1];
    var _f = useState(addMonth(defaultFin, 2)), max = _f[0], setMax = _f[1];
    var values = getMonthBetweenTowMonth(min, max);
    var marks = [];
    var lastLabelMonth = null;
    var index = 0;
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value_1 = values_1[_i];
        var _g = getYearAndMonthInStringDate(value_1), Annee = _g.Annee, Mois = _g.Mois;
        var labelDate = "".concat(converMonthToString(Mois), " ").concat(Annee);
        marks.push({
            value: index,
            month: value_1,
            label: lastLabelMonth && index !== values.length - 1
                ? labelDate.replace(lastLabelMonth, '')
                : labelDate,
        });
        lastLabelMonth = labelDate.split(' ')[1];
        index++;
    }
    var getMark = function (markSelected) {
        var result = marks.find(function (mark) { return markSelected === mark.month; });
        return result ? result.value : null;
    };
    var _h = useState([
        getMark(defaultDebut),
        getMark(defaultFin),
    ]), value = _h[0], setValue = _h[1];
    var valueLabelFormat = function (value) {
        var _a = getYearAndMonthInStringDate(value), Annee = _a.Annee, Mois = _a.Mois;
        return converYearMonthToString(concatYearsAndMonth(Annee, Mois));
    };
    var handleChange = function (event, newValue) {
        var indexMin = newValue[0];
        var indexMax = newValue[1];
        if (indexMin === value[0] && indexMax === value[1]) {
            event.preventDefault();
            return;
        }
        var moveMax = indexMin === value[0] && indexMax !== value[1];
        var moveMin = indexMax === value[1] && indexMin !== value[0];
        var diff = Math.abs(indexMax - indexMin);
        var hasDiff = (maxDiff !== null && diff > maxDiff) ||
            (minDiff !== null && diff < minDiff);
        if (hasDiff) {
            if (moveMax && maxDiff !== null) {
                indexMin = indexMax - maxDiff;
            }
            else if (moveMin) {
                indexMax = indexMin + (minDiff !== null ? minDiff : maxDiff);
            }
        }
        if (indexMin < 0 || indexMax >= marks.length) {
            event.preventDefault();
            return;
        }
        setValue([indexMin, indexMax]);
        var _a = getYearAndMonthInStringDate(marks.find(function (mark) { return indexMin === mark.value; }).month), AnneeDebut = _a.Annee, MoisDebut = _a.Mois;
        var _b = getYearAndMonthInStringDate(marks.find(function (mark) { return indexMax === mark.value; }).month), AnneeFin = _b.Annee, MoisFin = _b.Mois;
        onChange(concatYearsAndMonth(AnneeDebut, MoisDebut), concatYearsAndMonth(AnneeFin, MoisFin));
    };
    if (!marks.length) {
        return;
    }
    return (_jsx(_Fragment, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", spacing: 3 }, { children: [_jsx(SliderMui, { sx: { minHeight: 300 }, value: value, min: marks[0].value, max: marks[marks.length - 1].value, getAriaValueText: valueLabelFormat, valueLabelFormat: valueLabelFormat, onChange: handleChange, marks: marks, size: "small", orientation: "vertical" }), _jsxs(Stack, __assign({ justifyContent: "space-between", spacing: 2 }, { children: [_jsxs(Stack, { children: [_jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", onClick: function () {
                                        setMax(addMonth(max, 1));
                                    } }, { children: _jsx(ExpandLessIcon, { fontSize: "small" }) })), _jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", onClick: function () {
                                        setMax(addMonth(max, -1));
                                    }, disabled: getMark(max) === value[1] }, { children: _jsx(ExpandIcon, { fontSize: "small" }) }))] }), _jsxs(Stack, { children: [_jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", disabled: getMark(min) === value[0], onClick: function () {
                                        setMin(addMonth(min, 1));
                                        setValue([value[0] - 1, value[1] - 1]);
                                    } }, { children: _jsx(ExpandLessIcon, { fontSize: "small" }) })), _jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", onClick: function () {
                                        setMin(addMonth(min, -1));
                                        setValue([value[0] + 1, value[1] + 1]);
                                    } }, { children: _jsx(ExpandIcon, { fontSize: "small" }) }))] })] }))] })) }));
};
//# sourceMappingURL=SliderMonth.js.map